import React, { useState } from "react";
import Cropper from "react-easy-crop";
import Modal from "../modal";
import Button from "../new-button";
import { cropImage } from "../../../helpers/cropUtils";
import styles from "./styles.module.scss";

const ImageCropper = ({
  open,
  image,
  onComplete,
  onClose,
  aspect = 1,
  containerStyle = {},
  ...props
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const handleCropComplete = (_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const handleFinish = async () => {
    if (croppedAreaPixels) {
      try {
        const croppedImage = await cropImage(
          image,
          croppedAreaPixels,
          console.error,
        );
        onComplete(croppedImage);
      } catch (error) {
        console.error("Error cropping image:", error);
      }
    }
  };

  const handleClose = () => {
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCroppedAreaPixels(null);
    onClose();
  };

  return (
    <Modal
      isOpen={open}
      onClose={handleClose}
      header="Crop Image"
      size="md"
      notCentered
    >
      <div className={styles.v2ImageCropper}>
        <div className={styles.cropperContainer} style={containerStyle}>
          <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={aspect}
            onCropChange={setCrop}
            onCropComplete={handleCropComplete}
            onZoomChange={setZoom}
            showGrid={false}
            {...props}
          />
        </div>

        <div className={styles.controls}>
          <div className={styles.zoomControl}>
            <label className={styles.label}>Zoom</label>
            <input
              type="range"
              min="1"
              max="3"
              step="0.1"
              value={zoom}
              onChange={(e) => setZoom(Number(e.target.value))}
              className={styles.zoomSlider}
            />
            <span className={styles.zoomValue}>{Math.round(zoom * 100)}%</span>
          </div>
        </div>

        <div className={styles.actions}>
          <Button type="button" variant="ghost" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleFinish}
            disabled={!croppedAreaPixels}
          >
            Crop
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ImageCropper;
